document.addEventListener("DOMContentLoaded", function () {
  // back to top js
  // const backToTop = document.getElementById("back-to-top");
  // window.addEventListener("scroll", () => {
  //   if (window.scrollY > 300) {
  //     backToTop.style.display = "block";
  //   } else {
  //     backToTop.style.display = "none";
  //   }
  // });

  // backToTop.addEventListener("click", (e) => {
  //   e.preventDefault();
  //   window.scrollTo({ top: 0, behavior: "smooth" });
  // });

  // // loader js
  // window.addEventListener('load', function () {
  //   var loader = document.getElementById('page-loader');
  //   if (loader) {
  //     loader.style.opacity = '0';
  //     loader.style.transition = 'opacity 0.5s ease';
  //     setTimeout(function () {
  //       loader.style.display = 'none';
  //     }, 500);
  //   }
  // });

});